import { useEffect, useState } from 'react';
import { View } from 'react-native';

import { Button, COLORS, Select, Text } from '../Basics';
import { Screen } from '../../screens/Screen';
import LorentzService from '../../services/LorentzService';
import { useStore } from '../../store/Context';

/**
 * Quando o operador muda para "Pausa" sem motivo fixo no JSON,
 * exibe motivos carregados de CTI_MOTIVO_PAUSA_PRODUTIVA.
 */
export const PauseReasonModal = () => {
  const { lorentzPauseReasons = [], setSettings } = useStore();
  const [visible, setVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [pendingStatus, setPendingStatus] = useState('away');

  useEffect(() => {
    const onPick = ev => {
      const data = ev.detail || ev.data || {};
      setPendingStatus(data.status || 'away');
      setSelectedId(null);
      setVisible(true);
    };

    document.addEventListener('lorentz:pause:pick-reason', onPick);
    return () =>
      document.removeEventListener('lorentz:pause:pick-reason', onPick);
  }, []);

  const options = lorentzPauseReasons.map(r => ({
    value: String(r.id ?? r.cod ?? r.Cod),
    text: r.name ?? r.desc ?? r.Desc ?? `Motivo ${r.id ?? r.cod}`
  }));

  const handleConfirm = async () => {
    if (!selectedId) return;
    setVisible(false);
    await LorentzService.onStatusChange(pendingStatus, {
      reasonId: Number(selectedId)
    });
    setSettings({ status: pendingStatus });
  };

  const handleCancel = () => {
    setVisible(false);
    setSettings({ status: 'online' });
  };

  if (!visible || options.length === 0) return null;

  return (
    <Screen
      visible
      closeable
      onClose={handleCancel}
      color="rgba(0,0,0,0.4)"
      bodyStyle={{ justifyContent: 'center', alignItems: 'center' }}
    >
      <View
        style={{
          width: '90%',
          maxWidth: 320,
          backgroundColor: COLORS.app,
          borderRadius: 8,
          padding: 16
        }}
      >
        <Text style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 12 }}>
          Motivo da pausa
        </Text>
        <Select options={options} value={selectedId} onChange={setSelectedId} />
        <View style={{ flexDirection: 'row', marginTop: 16 }}>
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            <Text>Cancelar</Text>
          </Button>
          <Button color="primary" style={{ flex: 1 }} onClick={handleConfirm}>
            <Text style={{ color: '#fff' }}>Confirmar</Text>
          </Button>
        </View>
      </View>
    </Screen>
  );
};

export default PauseReasonModal;
